module.exports = __webpack_public_path__ + "img/footerbg.96b22361.png";